import { jsx as _jsx } from "react/jsx-runtime";
// Vendored from shadcn — see ./index.ts for provenance and our divergences.
import * as React from "react";
import { cva } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../../utils";
const markerVariants = cva("group/marker relative flex min-h-4 w-full items-center gap-2 text-left text-sm text-muted-foreground [&_svg:not([class*='size-'])]:size-4 [a]:underline [a]:underline-offset-3 [a]:hover:text-foreground", {
    variants: {
        variant: {
            default: "",
            separator: "before:mr-1 before:h-px before:min-w-0 before:flex-1 before:bg-border after:ml-1 after:h-px after:min-w-0 after:flex-1 after:bg-border",
            border: "border-b border-border pb-2"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Marker({ className, variant = "default", asChild = false, ...props }) {
    const Comp = asChild ? Slot : "div";
    return /*#__PURE__*/ _jsx(Comp, {
        "data-slot": "marker",
        "data-variant": variant,
        className: cn(markerVariants({
            variant,
            className
        })),
        ...props
    });
}
const markerIconVariants = cva("size-4 shrink-0 [&_svg:not([class*='size-'])]:size-4", {
    variants: {
        /*
       * The brand accent belongs to the assistant's own status rows, not to
       * every marker — a truncation or error marker tinted `success` reads as
       * a success. Anything else inherits the marker row's colour.
       */ variant: {
            default: "text-current",
            ai: "text-success"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function MarkerIcon({ className, variant = "default", ...props }) {
    return /*#__PURE__*/ _jsx("span", {
        "data-slot": "marker-icon",
        "aria-hidden": "true",
        className: cn(markerIconVariants({
            variant,
            className
        })),
        ...props
    });
}
function MarkerContent({ className, ...props }) {
    return /*#__PURE__*/ _jsx("span", {
        "data-slot": "marker-content",
        className: cn("min-w-0 wrap-break-word group-data-[variant=separator]/marker:flex-none group-data-[variant=separator]/marker:text-center *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", className),
        ...props
    });
}
export { Marker, MarkerIcon, MarkerContent, markerVariants, markerIconVariants };

//# sourceMappingURL=marker.js.map